// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_button__4-vvU {
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 12px;
  background: #cc137c;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  gap: 6px;
}

.button_button__4-vvU span {
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.button_img__RInS- {
  width: 24px;
  height: 24px;
}
.button_outline__oSx\\+1 {
  border-radius: 12px;
  background: #f0f0f0;
}
.button_outline__oSx\\+1 span {
  color: #101010;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
}
`, "",{"version":3,"sources":["webpack://./src/components/button/button.module.css"],"names":[],"mappings":"AAAA;EAEE,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EAEnB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC","sourcesContent":[".button {\n  border-radius: 72px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  border-radius: 12px;\n  background: #cc137c;\n  gap: 8px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 48px;\n  gap: 6px;\n}\n\n.button span {\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.img {\n  width: 24px;\n  height: 24px;\n}\n.outline {\n  border-radius: 12px;\n  background: #f0f0f0;\n}\n.outline span {\n  color: #101010;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px; /* 142.857% */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button_button__4-vvU`,
	"img": `button_img__RInS-`,
	"outline": `button_outline__oSx+1`
};
export default ___CSS_LOADER_EXPORT___;
